import { RouteRecordRaw } from 'vue-router';

const TEAM_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'TeamsOverview',
      component: () => import('@/modules/teams/pages/TeamsOverview.vue'),
   },
   {
      path: ':id',
      name: 'TeamDetail',
      component: () => import('@/modules/teams/pages/TeamDetail.vue'),
      children: [
         {
            path: 'general',
            alias: '',
            name: 'TeamGeneral',
            component: () => import('@/modules/teams/components/team-detail/TeamGeneral.vue'),
         },
         {
            path: 'permissions',
            alias: 'permission',
            name: 'TeamPermissions',
            component: () => import('@/modules/teams/components/team-detail/TeamPermissions.vue'),
         },
      ],
   },
];

export default TEAM_ROUTES;
